import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {FetchPaymentInfoResponse} from '../../models/payment-details-model';
import {PaymentResponse} from '../../models/payment-response.model';
import {PaidPaymentCollection} from '../../models/additional-pac-data.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentDetailsService {

  constructor(private readonly http: HttpClient) {}

  fetchDetails(paymentReferenceNumber: string, payerID: string): Observable<FetchPaymentInfoResponse[]> {
    const appToken = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${appToken}`
    });

    const payload = {
      objPASRequest: {
        paymentReferenceNumber,
        payerID
      }
    };
    return this.http.post<FetchPaymentInfoResponse[]>('api/fetch-payment-details', payload, { headers });
  }

  submitPayment(paidPaymentCollection: PaidPaymentCollection, selectedPACs: string[], payerId: string | undefined, kioskCode: string | undefined): Observable<PaymentResponse> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    const payload = {
      wsCollectionInfo: {
        paymentReferenceNumber: {
          item: selectedPACs
        },
        totalReceiptAmount: paidPaymentCollection.paymentAmount,
        payerID: payerId,
        cashCounterID: kioskCode,
        wsCollectionLine: {
          item: [
            {
              paymentMode: paidPaymentCollection.paymentMode,
              bankCode: paidPaymentCollection.bankCode,
              transactionAmount: paidPaymentCollection.paymentAmount,
              transactionReference: paidPaymentCollection.transactionId
            }
          ]
        }
      }
    };

    return this.http.post<PaymentResponse>('api/process-payment', payload, { headers });
  }
}
